import React from 'react';
import { Link } from 'react-router-dom';
import { CONTACT_US } from '../constants/common'

class ContactUs extends React.Component {
  constructor(props) {
    super(props);
    this.state = { activeTab: 'customer' };
  }

  render() {
  const { activeTab } = this.state;

  const cardBase = {
    background: 'rgba(30,26,61,0.85)',
    border: '1px solid rgba(199,125,204,0.18)',
    borderRadius: 18,
    boxShadow: '0 8px 32px rgba(0,0,0,0.32)',
  };

  const iconBox = (emoji) => (
    <div style={{
      width: 44,
      height: 44,
      borderRadius: 12,
      background: 'linear-gradient(135deg, rgba(146,90,148,0.3), rgba(199,125,204,0.15))',
      border: '1px solid rgba(199,125,204,0.25)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 20,
      flexShrink: 0,
    }}>{emoji}</div>
  );

  const infoRow = (emoji, label, value, href) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '14px 0', borderBottom: '1px solid rgba(199,125,204,0.08)' }}>
      {iconBox(emoji)}
      <div>
        <div style={{ color: '#b3b2c7', fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: 3 }}>{label}</div>
        {href
          ? <a href={href} target="_blank" rel="noopener noreferrer" style={{ color: '#fff', fontSize: 15, fontWeight: 600, textDecoration: 'none' }}>{value}</a>
          : <div style={{ color: '#fff', fontSize: 15, fontWeight: 600 }}>{value}</div>
        }
      </div>
    </div>
  );

  const tabs = [
    { key: 'customer', label: 'Customers' },
    { key: 'partner', label: 'Partners' },
    { key: 'grievance', label: 'Grievance' },
  ];

  return (
    <div style={{ background: 'var(--dark-bg, #0F0C29)', minHeight: '100vh', paddingBottom: 60 }}>

      {/* Hero */}
      <div style={{ padding: '48px 24px 0', textAlign: 'center', maxWidth: 680, margin: '0 auto' }}>
        <h1 style={{ color: '#fff', fontSize: 'clamp(28px, 5vw, 44px)', fontWeight: 800, margin: 0, lineHeight: 1.15 }}>
          Get in Touch With Us
        </h1>
        <p style={{ color: '#b3b2c7', marginTop: 12, fontSize: 16, lineHeight: 1.7 }}>
          We're here to help. Reach out for loan enquiries, partnership opportunities, or support.
        </p>
      </div>

      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '40px 20px 0' }}>

        {/* Top row — Map + Quick Contact */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 24, marginBottom: 24 }}>

          {/* Map card */}
          <div style={{ ...cardBase, padding: 0, overflow: 'hidden', gridColumn: 'span 1' }}>
            <div style={{ padding: '20px 24px 14px', borderBottom: '1px solid rgba(199,125,204,0.1)' }}>
              <div style={{ color: '#c77dcc', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: 4 }}>Our Office</div>
              <div style={{ color: '#fff', fontSize: 17, fontWeight: 700 }}>Ascend Capital, Jaipur</div>
            </div>
            <iframe
              title="Ascend Capital Address"
              width="100%"
              height="240"
              frameBorder="0"
              style={{ display: 'block' }}
              src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJE43-Ezu1bTkRXAt5IFoHIUw&key=AIzaSyDMUc9-HHJgfTFddkLT71l_47oSzdXxeH8"
            />
            <div style={{ padding: '16px 24px', display: 'flex', alignItems: 'flex-start', gap: 12 }}>
              <div style={{ flex: 1 }}>
                <div style={{ color: '#b3b2c7', fontSize: 13, lineHeight: 1.6 }}>
                  601-610, 4th Floor, Anchor Mall,<br />Civil Lines, Jaipur 302006
                </div>
              </div>
              <a
                href="https://www.google.com/maps/place/Ascend+Capital/@26.8953783,75.7848305,19z"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  background: 'linear-gradient(135deg, #925a94, #c77dcc)',
                  color: '#fff',
                  padding: '10px 18px',
                  borderRadius: 10,
                  fontSize: 13,
                  fontWeight: 700,
                  textDecoration: 'none',
                  whiteSpace: 'nowrap',
                  flexShrink: 0,
                }}
              >
                Get Directions
              </a>
            </div>
          </div>

          {/* Tabbed contact info */}
          <div style={{ ...cardBase, padding: 0, overflow: 'hidden' }}>
            {/* Tab header */}
            <div style={{ display: 'flex', borderBottom: '1px solid rgba(199,125,204,0.1)' }}>
              {tabs.map(t => (
                <button
                  key={t.key}
                  onClick={() => this.setState({ activeTab: t.key })}
                  style={{
                    flex: 1,
                    padding: '16px 8px',
                    background: 'none',
                    border: 'none',
                    borderBottom: activeTab === t.key ? '2px solid #c77dcc' : '2px solid transparent',
                    color: activeTab === t.key ? '#fff' : '#b3b2c7',
                    fontWeight: activeTab === t.key ? 700 : 500,
                    fontSize: 13,
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    letterSpacing: '0.3px',
                  }}
                >
                  {t.label}
                </button>
              ))}
            </div>

            <div style={{ padding: '20px 24px' }}>
              {activeTab === 'customer' && (
                <div>
                  <div style={{ color: '#c77dcc', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: 4 }}>Customer Support</div>
                  <div style={{ color: '#fff', fontSize: 16, fontWeight: 700, marginBottom: 18 }}>We're here to help you</div>
                  {infoRow('📞', 'Mobile', `+91-${CONTACT_US}`, `tel:+91${CONTACT_US}`)}
                  {infoRow('✉️', 'Email', 'info@ascendcap.in', 'mailto:info@ascendcap.in')}
                  <div style={{ marginTop: 20 }}>
                    <Link to="/apply" style={{
                      display: 'block',
                      textAlign: 'center',
                      background: 'linear-gradient(135deg, #925a94, #c77dcc)',
                      color: '#fff',
                      padding: '13px',
                      borderRadius: 10,
                      fontWeight: 700,
                      fontSize: 14,
                      textDecoration: 'none',
                      letterSpacing: '0.3px',
                    }}>
                      Apply for a Loan
                    </Link>
                  </div>
                </div>
              )}

              {activeTab === 'partner' && (
                <div>
                  <div style={{ color: '#c77dcc', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: 4 }}>Partner Enquiries</div>
                  <div style={{ color: '#fff', fontSize: 16, fontWeight: 700, marginBottom: 18 }}>Grow with Ascend Capital</div>
                  {infoRow('📞', 'Mobile', '+91-9001772907', 'tel:+919001772907')}
                  {infoRow('✉️', 'Email', 'info@ascendcap.in', 'mailto:info@ascendcap.in')}
                  <div style={{ marginTop: 20 }}>
                    <Link to="/partner_with_us" style={{
                      display: 'block',
                      textAlign: 'center',
                      background: 'linear-gradient(135deg, #925a94, #c77dcc)',
                      color: '#fff',
                      padding: '13px',
                      borderRadius: 10,
                      fontWeight: 700,
                      fontSize: 14,
                      textDecoration: 'none',
                    }}>
                      Partner Enquiry
                    </Link>
                  </div>
                </div>
              )}

              {activeTab === 'grievance' && (
                <div>
                  <div style={{ color: '#c77dcc', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: 4 }}>Grievance Redressal</div>
                  <div style={{ color: '#fff', fontSize: 16, fontWeight: 700, marginBottom: 18 }}>Principal Nodal Officer</div>
                  {infoRow('👤', 'Officer', 'Mr. Deepak Kumawat')}
                  {infoRow('📞', 'Mobile', '8741092723', 'tel:+918741092723')}
                  {infoRow('✉️', 'Email', 'accounts@ascendcap.in', 'mailto:accounts@ascendcap.in')}
                  <div style={{ marginTop: 20 }}>
                    <a
                      href="https://forms.gle/yK4nHt1aqG6mfWcM7"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        display: 'block',
                        textAlign: 'center',
                        background: 'linear-gradient(135deg, #925a94, #c77dcc)',
                        color: '#fff',
                        padding: '13px',
                        borderRadius: 10,
                        fontWeight: 700,
                        fontSize: 14,
                        textDecoration: 'none',
                      }}
                    >
                      Submit Grievance
                    </a>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Bottom info strip */}
        <div style={{
          ...cardBase,
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: 0,
          overflow: 'hidden',
        }}>
          {[
            { emoji: '⏰', label: 'Working Hours', value: 'Mon – Sat, 9am – 6pm' },
            { emoji: '📍', label: 'Headquarters', value: 'Jaipur, Rajasthan' },
            { emoji: '🌐', label: 'Website', value: 'ascendcap.in' },
            { emoji: '📋', label: 'NBFC Reg.', value: 'Ascend Bizcap Pvt. Ltd.' },
          ].map((item, i, arr) => (
            <div
              key={i}
              style={{
                padding: '22px 24px',
                borderRight: i < arr.length - 1 ? '1px solid rgba(199,125,204,0.1)' : 'none',
                display: 'flex',
                alignItems: 'center',
                gap: 14,
              }}
            >
              <div style={{
                width: 40, height: 40, borderRadius: 10,
                background: 'rgba(146,90,148,0.15)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 18, flexShrink: 0,
              }}>{item.emoji}</div>
              <div>
                <div style={{ color: '#b3b2c7', fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.8px' }}>{item.label}</div>
                <div style={{ color: '#fff', fontSize: 14, fontWeight: 600, marginTop: 3 }}>{item.value}</div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
    );
  }
}

export default ContactUs;



// WEBPACK FOOTER //
// ./src/components/ContactUs.js